{
  "instances": {
    "beans": {
      "label": "Beans",
      "name": "Nom",
      "aliases": "Alias",
      "type": "Type",
      "resource": "Ressource",
      "dependencies": "Dépendances"
    }
  }
}
